import { useMemo, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@ellucian/react-design-system/core';
import { spacing40, spacing60, spacing20, spacing30 } from '@ellucian/react-design-system/core/styles/tokens';
import { Paper, Typography } from '@ellucian/react-design-system/core';
import { FormattedMessage, useIntl } from 'react-intl';
import UAEPassButton from './UAEPassButton';
import { useSnackbar } from '../SnackbarContext/SnackbarContext';
import { SUPPORTED_FEATURES } from '@nsr/applicant-apply-shared/src/helpers/featureFlags';

const LOGIN_PATH = '/auth/uaepass/login';

const useStyles = makeStyles({
    name: 'UAELogin'
})(() => ({
    root: {
        margin: `${spacing60} auto 0 auto`,
        maxWidth: '580px',
        padding: spacing40,
    },
    heading: {
        marginBottom: spacing20,
    },
    body: {
        marginBottom: spacing30,
    },
    actions: {
        display: 'flex',
        gap: spacing20,
        flexWrap: 'wrap',
        justifyContent: 'center',
    }
}));

const UAELogin = () => {
    const { classes } = useStyles();
    const history = useHistory();
    const intl = useIntl();
    const snackbar = useSnackbar();
    const uaepassEnabled = window.PRELOADED_STATE?.globalSettings?.uaepassSettings?.enabled === true
        && window.PRELOADED_STATE?.featureSupported?.[SUPPORTED_FEATURES.uaepass] === true;
    const uaePassErrorMessageId = window.PRELOADED_STATE?.uaePassError?.messageId;

    useEffect(() => {
        if (!uaepassEnabled) {
            history.replace('/applicant/retrieval');
        }
    }, []); 

    useEffect(() => {
        if (uaePassErrorMessageId) {
            snackbar.error(intl.formatMessage({ id: uaePassErrorMessageId }));
            window.PRELOADED_STATE.uaePassError = undefined;
        }
    }, [uaePassErrorMessageId, intl, snackbar]);

    const startLogin = useMemo(() => () => {
        window.location.assign(LOGIN_PATH);
    }, []);

    if (!uaepassEnabled) {
        return null;
    }

    return (
        <Paper className={classes.root}>
            <Typography variant="h1" className={classes.heading}>
                <FormattedMessage id="uaePassLoginHeading" defaultMessage="UAEPASS Login" />
            </Typography>
            <Typography variant="body1" className={classes.body}>
                <FormattedMessage 
                    id="uaePassLoginDescription" 
                    defaultMessage="Use your UAEPASS digital identity to securely access your application. You will be redirected to UAEPASS for authentication and then returned here."
                />
            </Typography>
            <div className={classes.actions}>
                <UAEPassButton
                    variant="outline"
                    onClick={startLogin}
                />
            </div>
        </Paper>
    );
};

export default UAELogin;
